export const PlanRoutes = {
	Local: 'http://localhost:1600',
	LocalLive: 'http://localhost:1610',
	Cypress: 'http://localhost:1620',
	Test: 'https://plan.stage.agilox.net',
	Beta: 'https://plan.beta.agilox.net',
	Live: 'https://plan.agilox.net',
	Stage: 'https://plan.stage.agilox.net',
} as const;
